import React from "react";
import { DeckGlobeMap } from "./DeckGlobeMap";
import { FONT_FAMILY, COLORS } from "../theme";
import { Legend } from "./Legend";

interface DeckGlobePaneSubAllotmentProps {
    imageIndex: number;
    BITMAP_IMAGES: (string | HTMLImageElement)[];
    viewState?: any;
    onViewStateChange?: (params: any) => void;
    metadataText: string;
    metadataLink: string;
    metadataLinkTitle?: string;
    showLegend?: boolean;
    title?: string;
}

export const DeckGlobePaneSubAllotment: React.FC<DeckGlobePaneSubAllotmentProps> = ({
    imageIndex,
    BITMAP_IMAGES,
    viewState,
    onViewStateChange,
    metadataText,
    metadataLink,
    metadataLinkTitle = "View model run on Weights & Biases",
    showLegend = false,
    title
}) => (
    <div style={{ width: "100%", height: "100%", position: "relative", fontFamily: FONT_FAMILY }}>
        <div
            style={{
                width: "100%",
                height: "100%",
                backgroundImage: "url('https://www.solarsystemscope.com/textures/download/8k_stars.jpg')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1
            }}
        >
            <DeckGlobeMap
                layerConfigs={[
                    {
                        imageIndex: imageIndex,
                        bitmapImages: BITMAP_IMAGES,
                        show: true,
                        transparency: 1.0
                    }
                ]}
                viewState={viewState}
                onViewStateChange={onViewStateChange}
            />

            {/* Title box */}
            {title && (
                <div style={{
                    position: 'absolute',
                    bottom: 16,
                    right: 16,
                    background: 'rgba(30, 30, 40, 0.85)',
                    color: '#fff',
                    padding: '8px 14px',
                    borderRadius: 6,
                    fontSize: 13,
                    fontWeight: 400,
                    zIndex: 500,
                    boxShadow: COLORS.boxShadow,
                    pointerEvents: 'auto',
                    fontFamily: FONT_FAMILY,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                }}>
                    {title}
                </div>
            )}
        </div>

        {/* Legend - positioned at top right, outside the inner div */}
        {showLegend && (
            <Legend COLORS={COLORS} FONT_FAMILY={FONT_FAMILY} />
        )}
    </div>
);